module.exports = __webpack_public_path__ + "img/cruises-3.796cf6e0.png";